import { ProductExternal } from '@nemuru-eng/js-api-client';

import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ICON_NAMES } from '@/config/config';

const Icons: Record<ProductExternal, string> = {
  [ProductExternal.CONSUMER_LOAN]: ICON_NAMES.CONSUMER_LOAN,
  [ProductExternal.AUTO]: ICON_NAMES.AUTO,
  [ProductExternal.CREDIT_LINE]: ICON_NAMES.CREDIT_LINE,
  [ProductExternal.BNPL]: ICON_NAMES.BNPL,
  [ProductExternal.PAY_BY_LINK]: ICON_NAMES.PAY_BY_LINK,
};

const Paths: Record<ProductExternal, string> = {
  [ProductExternal.CONSUMER_LOAN]: DYNAMIC_PAGE_PATHS.CONSUMER_LOAN_LIST,
  [ProductExternal.AUTO]: DYNAMIC_PAGE_PATHS.AUTO_LOAN_LIST,
  [ProductExternal.CREDIT_LINE]: DYNAMIC_PAGE_PATHS.CREDIT_LINE_LIST,
  [ProductExternal.BNPL]: DYNAMIC_PAGE_PATHS.ORDER_LIST,
  [ProductExternal.PAY_BY_LINK]: DYNAMIC_PAGE_PATHS.PAY_BY_LINK_LIST,
};

export class ProductExternalMap {
  public static toIcon(productExternal: ProductExternal): string {
    if (!(productExternal in Icons)) {
      throw new Error(`ProductExternal ${productExternal} is not supported`);
    }
    return Icons[productExternal];
  }

  public static toPath(productExternal: ProductExternal): string {
    if (!(productExternal in Paths)) {
      throw new Error(`ProductExternal ${productExternal} is not supported`);
    }
    return Paths[productExternal];
  }
}
